import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationPushLogService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  public getPushLog() {
    return this.http.get<PushLog>(this.url('/push-log'));
  }

  public getPushLogStats() {
    return this.http.get(this.url('/push-log/stats'));
  }

  public setPushLog(data: PushLogConfig) {
    return this.http.put(this.url('/push-log'), data);
  }

  public deletePushLog() {
    return this.http.delete(this.url('/push-log'));
  }
}

export type PushLogConfig = {
  type: PushLogConfigType;
  configuration: string;
}

export type PushLog = PushLogConfig & {
  uuid: string;
}

export const PushLogConfigTypes = ['tcp', 'splunk', 'sekoia', 'microsoftSentinelv2', 'syslog'] as const;

export type PushLogConfigType = typeof PushLogConfigTypes[number];
